<template>
  <div class="time-setup">
    <div class="time-setup__header">
      <v-icon color="primary" class="time-setup__header-icon">mdi-clock-outline</v-icon>
      <h2 class="time-setup__title">Настройки времени</h2>
    </div>
    <v-form ref="formTimeDoorphone" v-model="validTime" lazy-validation>
      <v-row>
        <v-col cols="12" md="6" class="pb-0">
          <v-row>
            <v-col cols="12" class="py-0 pt-2">
              <v-select
                v-model="formTime.formatDate"
                :items="dateFormats"
                label="Формат даты"
                outlined
                dense
                flat
                prepend-inner-icon="mdi-calendar"
                class="time-setup__field"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-select
                v-model="formTime.displayLanguage"
                :items="['Eng', 'Рус']"
                label="Язык дисплея"
                outlined
                dense
                flat
                prepend-inner-icon="mdi-translate"
                class="time-setup__field"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formTime.mainServer"
                flat
                outlined
                dense
                label="Основной сервер"
                prepend-inner-icon="mdi-server"
                class="time-setup__field"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formTime.additionalServer"
                flat
                outlined
                dense
                label="Дополнительный сервер"
                prepend-inner-icon="mdi-server-network"
                class="time-setup__field"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-select
                v-model="formTime.formatTime"
                :items="timeFormats"
                label="Формат времени"
                outlined
                dense
                flat
                prepend-inner-icon="mdi-clock-outline"
                class="time-setup__field"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-select
                v-model="formTime.timezone"
                :items="timeZoneArray"
                label="Часовой пояс"
                outlined
                dense
                flat
                prepend-inner-icon="mdi-earth"
                class="time-setup__field"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formTime.updateInterval"
                flat
                outlined
                dense
                type="number"
                label="Интервал обновления"
                :rules="rules.number"
                prepend-inner-icon="mdi-timer-outline"
                class="time-setup__field"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formTime.version"
                flat
                outlined
                dense
                label="Версия оборудования"
                :disabled="true"
                prepend-inner-icon="mdi-chip"
                class="time-setup__field"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="time-setup__actions">
        <v-btn
          color="primary"
          class="text-none"
          rounded
          @click="validateTimeSettings()"
        >
          <v-icon left>mdi-content-save-outline</v-icon>
          Сохранить
        </v-btn>
        <v-btn
          color="primary"
          outlined
          rounded
          class="text-none ml-2"
          @click.prevent="returnDoorphone && returnDoorphone()"
        >
          <v-icon left>mdi-close</v-icon>
          Отменить
        </v-btn>
      </div>
    </v-form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import { dateFormats, timeFormats, rules } from '../consts';

export default {
  name: 'TimeSetup',
  props: ['returnDoorphone'],
  data: () => ({
    validTime: true,
    dateFormats,
    timeFormats,
    rules,
    timeZoneArray: [],
    formTime: {
      formatDate: '',
      displayLanguage: '',
      mainServer: '',
      additionalServer: '',
      formatTime: '',
      timezone: '',
      updateInterval: '',
      version: '',
    },
  }),
  created () {
    this.getTimeSettings(this.$route.params.id)
      .then(() => {
        this.formTime.formatDate = this.dateFormats[this.timeSettings.cDateFormat];
        (this.timeSettings.cLCDLanguage === '4') ? this.formTime.displayLanguage = 'Рус' : this.formTime.displayLanguage = 'Eng';
        this.formTime.mainServer = this.timeSettings.cPrimaryNTPServer;
        this.formTime.additionalServer = this.timeSettings.cSecondryNTPServer;
        this.formTime.formatTime = this.timeFormats[this.timeSettings.cTimeFormat];
        this.formTime.updateInterval = this.timeSettings.cUpdateInterval;
        this.formTime.version = this.timeSettings.cGolbalHDVersion;
        this.timeSettings.cTimeZoneList.forEach((element, index) => {
          this.timeZoneArray.push(element + ' ' + this.timeSettings.cTimeZoneNameList[index]);
        });
        this.formTime.timezone = this.timeZoneArray[this.timeSettings.cTimeZoneNameIndex];
      })
      .catch(() => {
        this.$flash_warning('Ошибка получения настроек времени');
      });
  },
  methods: {
    ...mapActions({
      updateTimeSettings: 'Doorphone/updateTimeSettings',
      getTimeSettings: 'Doorphone/getTimeSettings',
    }),
    validateTimeSettings () {
      if (this.$refs.formTimeDoorphone.validate()) {
        const timezoneIndex = this.timeZoneArray.indexOf(this.formTime.timezone);
        const dataTime = {
          cTimeZoneName: this.timeSettings.cTimeZoneNameList[timezoneIndex],
          cTimeZone: this.timeSettings.cTimeZoneList[timezoneIndex],
          cPrimaryNTPServer: this.formTime.mainServer,
          cSecondryNTPServer: this.formTime.additionalServer,
          cUpdateInterval: this.formTime.updateInterval,
        };
        dataTime.cDateFormat = this.dateFormats.indexOf(this.formTime.formatDate);
        dataTime.cTimeFormat = this.timeFormats.indexOf(this.formTime.formatTime);
        (this.formTime.displayLanguage === 'Рус') ? dataTime.cLCDLanguage = '4' : dataTime.cLCDLanguage = '0';

        this.updateTimeSettings({
          id: this.$route.params.id,
          settings: dataTime,
        })
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене настроек времени');
          });
      } else {
        this.$flash_warning('Заполните все поля');
      }
    },
  },
  computed: {
    ...mapGetters({
      timeSettings: 'Doorphone/timeSettings',
    }),
  },
};
</script>

<style lang="scss" scoped>
.time-setup__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.time-setup__header-icon {
  flex-shrink: 0;
}

.time-setup__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.time-setup__field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}

.time-setup__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 32px;
}
</style>
